import { createActionGroup, emptyProps } from '@ngrx/store';

const LogActions = createActionGroup({
    source: 'Log',
    events: {
        'Send invalid user tariff log': emptyProps(),
        // 'Send log to mattermost': props<{
        //     message: string;
        // }>(),
    },
});

export default LogActions;
